import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';

import { reducer as FormReducer } from 'redux-form';
import { reducer as notifReducer } from 'redux-notifications';

import { Actions } from '@utils/actions';

/**
 * Third level of redux store: `state.app.breadcrumbs`
 */
export interface TBreadcrumbs {
  label: string;
  to?: string;
}

/**
 * First level of redux store: `state`
 */
export interface TState {
  notes: Array<String>;
  breadcrumbs: Array<TBreadcrumbs>;
}

export interface TRootState {
  app: TState;
  form: any;
  notifs: any;
}

/**
 * Action that comes to redux store
 */
export interface TAction {
  type: string;
  payload: any;
}

/**
 * Initial state of redux store
 */
export const InitialAppState: TState = {
  notes: [],
  breadcrumbs: []
};

export const Reducers = {
  [Actions.TEST_ACTION]: (state: TState, action: TAction) => {
    const newNote = { ...action.payload };
    const notes = [...state.notes, newNote];

    return { ...state, notes };
  },
  [Actions.BREADCRUMBS]: (state: TState, action: TAction) => {
    return { ...state, ...action.payload };
  }
};

export const AppReducer = handleActions(Reducers, InitialAppState);

export default combineReducers<TRootState>({ app: AppReducer, form: FormReducer, notifs: notifReducer });



// WEBPACK FOOTER //
// ./src/utils/reducer.ts